import type { RequestKind, RequestStatus, Urgency } from '@lorsamthai/ops-shared';

export const REQUEST_KIND_LABELS: Record<RequestKind, string> = {
  transfer_request: 'ขอโอนจากสาขาอื่น',
  purchase_request: 'ขอสั่งจาก supplier',
  stock_adjust: 'ปรับยอด stock',
  target_change: 'ขอปรับ min/target',
  demand_request: 'แจ้ง demand ลูกค้า',
};

export const REQUEST_KIND_ICONS: Record<RequestKind, string> = {
  transfer_request: '🔄',
  purchase_request: '🛒',
  stock_adjust: '✏️',
  target_change: '🎯',
  demand_request: '📣',
};

export const REQUEST_STATUS_LABELS: Record<RequestStatus, string> = {
  submitted: 'รอตรวจ',
  under_review: 'กำลังตรวจ',
  approved: 'อนุมัติแล้ว',
  rejected: 'ปฏิเสธ',
  fulfilled: 'เสร็จสิ้น',
  cancelled: 'ยกเลิก',
};

export const REQUEST_STATUS_TONES: Record<
  RequestStatus,
  'ok' | 'low' | 'warn' | 'danger' | 'info' | 'neutral'
> = {
  submitted: 'warn',
  under_review: 'info',
  approved: 'ok',
  rejected: 'danger',
  fulfilled: 'ok',
  cancelled: 'neutral',
};

export const URGENCY_LABELS: Record<Urgency, string> = {
  low: 'ต่ำ',
  normal: 'ปกติ',
  urgent: 'ด่วน',
};

export const URGENCY_TONES: Record<Urgency, 'neutral' | 'low' | 'danger'> = {
  low: 'neutral',
  normal: 'low',
  urgent: 'danger',
};
